import Cookies from "js-cookie";

export const getCookies = (cookiesKey: string) => {
  const value = Cookies.get(cookiesKey);
  return value;
};
